<template>
  <CustomHeaderTogglePanel>
    <template #header>
      <span class="x-title3">{{ $t(`facets.characteristics`) }}</span>
    </template>
    <Facets
      renderable-facets="facetNatural, facetVegan, facetSuitableForPregnancy"
      class="x-border-0 x-border-b x-border-neutral-10 x-py-24 x-pt-0"
    >
      <template #default="{ facet }">
        <FiltersList
          v-slot="{ filter }"
          :filters="facet.filters"
          :animation="staggeredFadeAndSlide"
          class="x-flex x-flex-col"
        >
          <SimpleFilter
            v-if="filter.label === '1' || filter.label === 'true'"
            :filter="filter"
            :css-classes="['x-facet-filter-lg x-w-full x-gap-4']"
          >
            <template #label>
              <CheckboxSelectedFilledIcon v-if="filter.selected" class="x-icon-lg x-text-lead-75" />
              <CheckboxUnselectedIcon v-else class="x-icon-lg" />
              <span class="x-font-main x-text-[18px] x-capitalize">
                {{ $t(`facets.${facet.label}`) }}
              </span>
            </template>
          </SimpleFilter>
        </FiltersList>
      </template>
    </Facets>
  </CustomHeaderTogglePanel>
</template>

<script setup lang="ts">
import {
  CheckboxSelectedFilledIcon,
  CheckboxUnselectedIcon,
  StaggeredFadeAndSlide,
} from '@empathyco/x-components'
import { Facets, FiltersList, SimpleFilter } from '@empathyco/x-components/facets'
import CustomHeaderTogglePanel from '../../custom-header-toggle-panel.vue'

const staggeredFadeAndSlide = StaggeredFadeAndSlide
</script>
